

















import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import ChangelogCard from '@/components/Changelog/ChangelogCard.vue';
import axios from 'axios';
import env from '@/env';
import draggable from 'vuedraggable';

@Component({
  components: { ChangelogCard, draggable }
})
export default class EditCutoverplanChangelogTab extends Vue {
  @Prop()
  cutoverplan?: Cutoverplan;

  dragOptions = {
    animation: 0,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost'
  };

  async addChangelog() {
    const { data: changelog } = await axios.post(`${env.backend_url}/changelog`, {
      cutoverplan_id: this.cutoverplan?.id,
      description: ''
    });
    if (this.cutoverplan?.changelogs) this.cutoverplan.changelogs.push(changelog);
  }
}
